import '../common/common';
import $ from 'jquery';
import Carousel from 'bootstrap/js/dist/carousel';
import Modal from 'bootstrap/js/dist/modal';

// Open photo submission modal
function openPhotoSubmissionModal() {
  const modal = new Modal(document.getElementById('photoSubmissionModal') as HTMLElement);
  modal.show();
}

// Sync thumbnail active state with carousel
function syncThumbnailsWithCarousel() {
  const carousel = document.getElementById('radioCarousel');
  if (carousel) {
    const thumbnails = document.querySelectorAll('.thumbnail-btn');
    const carouselInstance = Carousel.getOrCreateInstance(carousel);
    carouselInstance.cycle(); // Start auto-advance

    // Update thumbnail active state when carousel slides
    carousel.addEventListener('slide.bs.carousel', function(e: any) {
      thumbnails.forEach(function(thumb, index) {
        if (index === e.to) {
          thumb.setAttribute('aria-current', 'true');
          thumb.classList.add('active');
        } else {
          thumb.removeAttribute('aria-current');
          thumb.classList.remove('active');
        }
      });
    });

    // Stop auto-advance when user clicks carousel controls or thumbnails
    carousel.addEventListener('click', function() {
      carouselInstance.pause();
    });

    // Also pause on thumbnail click specifically
    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        carouselInstance.pause();
      });
    });
  }
}

// Expose the function to the window for onclick handlers
(window as any).openPhotoSubmissionModal = openPhotoSubmissionModal;

$(function() {
  syncThumbnailsWithCarousel();
});
